const blue = {
  primary: "#1890ff",
  pink: "#f4115d",
  leaf: "#70ac2d",
  scarlet: "#d0021b",
  orange: "#ef5e15",
  yellowDark: "#e7ad29",
  whitesmoke: "#efefef",
  black05: "rgba(0, 0, 0, 0.5)",
  borderColor: "rgba(0, 0, 0, 0.15)",
  border: "solid 1px rgba(0, 0, 0, 0.15)",
};

const normal = {
  "primary-color": "#1890ff", // primary color for all components
  "link-color": "#1890ff", // link color
  "success-color": "#52c41a", // success state color
  "warning-color": "#faad14", // warning state color
  "error-color": "#f5222d", // error state color
};

export { blue, normal };
